'use client';
import React from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
// import { fetcher } from '@/lib/fetcher';
import FeaturedCategoriesSlider from './FeaturedCategoriesSlider';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { FeaturedCategoriesSkeleton } from './FeaturedCategoriesSkeleton';
import { API_HOME_FEATURED_CATEGORIES } from '@/constant/apiRout';

// 🧠 Dynamically import the slider to reduce JS load

const FeaturedCategories = () => {
  // ✅ THIS IS HOW YOU GET THE DATA
  // const categories = await fetcher('/api/v2/home-featured-categories');
  const { data: categories, isLoading } = useFetcherCSR(
    API_HOME_FEATURED_CATEGORIES
  );

  if (isLoading) return <FeaturedCategoriesSkeleton />;

  // If there's no data, don't render anything
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <section className="featured-categories padding-top padding-bottom">
      <div className="container">
        {/* This header is now rendered on the SERVER, which is much faster */}
        <div className="section-header">
          <div className="section-header__content">
            <h2 className="margin-top-10">Featured categories</h2>
          </div>

          <div className="section-header__action d-none d-sm-block">
            <div className="swiper-nav swiper-nav--style1">
              <button className="swiper-nav__btn featured-categories__slider-prev">
                <FaArrowLeft />
              </button>
              <button className="swiper-nav__btn featured-categories__slider-next active">
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
        {/* Pass the server-fetched data down to the client component */}
        <FeaturedCategoriesSlider data={categories} />
      </div>
    </section>
  );
};

export default FeaturedCategories;
